import { chunk } from "lodash";
import moment from "moment";

import {
  ISO_DATE_FORMAT,
  iterateOverInterval,
  type MMMClientCycle,
} from "@north-beam/nb-common";

import { type Weekday } from "./date-stretch-compress-helpers";

export function getWeeksForDateRange(dateRange: {
  start_date: string;
  end_date: string;
}): { startDate: string; endDate: string }[] {
  const rangeDays = [
    ...iterateOverInterval({
      startDate: dateRange.start_date,
      endDate: dateRange.end_date,
    }),
  ];

  return chunk(rangeDays, 7).map((days) => ({
    startDate: days[0],
    endDate: days[days.length - 1],
  }));
}

export function getEndDateExclusiveWeeksForDateRange(dateRange: {
  start_date: string;
  end_date: string;
}) {
  return getWeeksForDateRange(dateRange).map((week) => ({
    ...week,
    endDate: moment(week.endDate).add(1, "day").format(ISO_DATE_FORMAT),
  }));
}

export function addDaysToIsoDate(date: string, days: number) {
  return moment(date).add(days, "days").format(ISO_DATE_FORMAT);
}

export function getDayOfWeekForIsoDate(date: string): Weekday {
  return moment(date).toDate().getDay();
}

export function getClosestUpcomingTuesday(date: string): string {
  const dayOfWeek = moment(date).day();
  const daysToAdd = (2 - dayOfWeek + 7) % 7;
  return moment(date).add(daysToAdd, "days").format(ISO_DATE_FORMAT);
}

export function getCycleInclusiveWeeks(cycle: MMMClientCycle) {
  return getWeeksForDateRange(cycle.date_range);
}

export function getAllDaysInDateRange(dateRange: {
  start_date: string;
  end_date: string;
}) {
  return [
    ...iterateOverInterval({
      startDate: dateRange.start_date,
      endDate: dateRange.end_date,
    }),
  ];
}

export function getCycleWeeksForBackend(cycle: MMMClientCycle) {
  return getCycleInclusiveWeeks(cycle).map((dateRange) => ({
    ...dateRange,
    endDate: moment(dateRange.endDate).add(1, "day").format(ISO_DATE_FORMAT),
  }));
}
